import { create } from "zustand";
import { canSee } from "./nav";
/**
 * Minimal route store. Apps that want real URL-backed routing can swap this
 * for React Router; pages don't care.
 */
export const useRoute = create((set) => ({
    page: "pos",
    drawerId: null,
    go: (page, role) => set({ page: canSee(page, role) ? page : "pos", drawerId: null }),
    openDrawer: (id) => set({ drawerId: id }),
    closeDrawer: () => set({ drawerId: null }),
}));
//# sourceMappingURL=router.js.map